export function ClipsIcon() {
  return (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 11H5V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19V11H17V9H21V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V9H7V11Z" fill="white"/>
    <path d="M9 13H7V11H9V13Z" fill="white"/>
    <path d="M13 13H11V11H13V13Z" fill="white"/>
    <path d="M17 13H15V11H17V13Z" fill="white"/>
    <path d="M11 11H9V9H11V11Z" fill="white"/>
    <path d="M15 11H13V9H15V11Z" fill="white"/>
    <path d="M20 4L3 8.5L2.5 6.5L19.5 2L20 4Z" fill="white"/>
  </svg>
  );
}
